import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppserviceService {
  baseUrl = '';
  loginheaders = new HttpHeaders(
    {
      'Content-Type':'application/json; charset=utf-8'
    });

  headers:any;
  user:string;
  adminBool:boolean = false;
  transactionsData:any;

  appData = {
    'engineers':[],
    'rslstores':[]
  };
  
  service = {
    'baseurl':'http://10.113.164.234:9000/',
    // 'baseurl':'http://localhost:3010/',
    'receipts':{
        'path': 'ui/parts/reserved?search_field=pwr_engineer&search_value=',
        'api':(window.location.hostname === 'localhost') ? this.getBaseUrl()/* 'http://localhost:3010/parts/' */: this.baseUrl
    },
    'feengineers':{
      'path':'ui/parts/feengineers'
    },
    'abandon':{
      'path':'ui/parts/engineer/workorder?per_code='
    },
    'abandonparts':{
      'path':'ui/parts/abandon?per_code='
    },
    'stockloaction':{
      'path':'ui/parts/stock_locations?search_string=',
      'type':'&stock_location_type='
    },
    'bootkit':{
      'path':'ui/parts/retrieveissueforviperbag'
    },
    'move':{
      'path': 'cgi-bin/PDA_EngName.pl?'
    }
  }
  serviceUrl:string;

  constructor(private Http:HttpClient) {}

  // Get and Set data 
  setUser(userValue){
    this.user = userValue;
  }

  setAdminBool(boolv){
    this.adminBool = boolv;
  }

  setTransactionData(transData){
    this.transactionsData = transData;
  }

  getAdminBool(){
    return this.adminBool;
  }

  getUser(){
    return this.user;
  }

  setBaseUrl(serUrl){
    this.baseUrl = serUrl;
  }

  getBaseUrl(){
    return this.baseUrl;
  }

  getTransactionData(){
    return this.transactionsData;
  }

  getServiceBaseUrl(urlPath){
    console.log(urlPath);
    return this.Http.get(urlPath,{
      headers:this.loginheaders
    });
  }

  getUsersData(urlPath){
    console.log(urlPath);
    return this.Http.get(urlPath);
  }

  setEngData(dataObj){
    this.appData['engineers'] = dataObj;
  }

  getEngData(){
    return this.appData['engineers'];
  }

  setRslData(dataObj){
    this.appData['rslstores'] = dataObj;
  }

  getRslData(){
    return this.appData['rslstores'];
  }

  // DB service calls
  getHeaders(){
    this.headers = new HttpHeaders(
      {
        'Content-Type':'application/json; charset=utf-8',
        'authorization':localStorage.getItem('authorization')
      })

    return this.headers
  }

  getSalt(logindetails):Observable<Object>{
    var input = {
      userid: logindetails['userid']                   
    };
    var url = this.getBaseUrl() + 'getsalt';
    return this.Http.post(url,input,{
      headers:this.loginheaders
    });
  }

  resetPassword(email):Observable<Object>{
    var input = {
      email: email,
      service: 'dispatch'
    };
    var url = this.getBaseUrl() + 'resetpassword';
    console.log(url);
    return this.Http.post(url,input,{
      headers:this.loginheaders
    });
  }

  updatePassword(input):Observable<Object>{
    var url = this.getBaseUrl() + 'updatepassword';
    console.log(url);
    return this.Http.post(url,input,{
      headers:this.loginheaders
    });
  }

  fetchAllWos(engineer):Observable<Object>{
    console.log(this.headers);
    var url = this.getBaseUrl() + "parts/search/" + engineer;
    return this.Http.get(url,{
        headers:this.getHeaders()
      });
  }

  fetchAbandonWos(engineer):Observable<Object>{
    console.log('Calling fetchAbandonWos');
    var url = this.getBaseUrl() + "parts/abandon/" + engineer;
    return this.Http.get(url,{
        headers:this.getHeaders()
      });
  }

  fetchAbandonParts(engineer):Observable<Object>{
    console.log('Calling fetchAbandonParts');
    console.log(engineer);
    var url = this.getBaseUrl() + "parts/abandonparts/" + engineer;
    return this.Http.get(url,{
        headers:this.getHeaders()
      });
  }

  getBootkitService(trackingobj):Observable<Object>{
    /* let headers = {
        headers:new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    let options = headers;
    let param = trackingobj;
    console.log(trackingobj, options);

    this.serviceUrl = this.service.baseurl + this.service['bootkit'].path
    return this.Http.post(this.serviceUrl,param.toString(),options); */
    var url = this.getBaseUrl() + "parts/bootkit";
    var bootkit = {
      'bootkit':{
        'prv_value':trackingobj['viperbag'],
        'prv_property': trackingobj['trackingMethod']
      }
    }

    return this.Http.post(url,bootkit,{
      headers:this.getHeaders()
    });
  }

  getBootkitPart(issueno):Observable<Object>{
    var url = this.getBaseUrl() + "parts/bootkitpart/" + issueno;
    return this.Http.get(url,{
      headers:this.getHeaders()
    });
  }

  rslPartAwait(partwo):Observable<Object>{
    var url = this.getBaseUrl() + "parts/bootkitpart/rslpartawait/" + partwo;
    return this.Http.get(url,{
      headers:this.getHeaders()
    });
  }

  rslPartUpdate(partwo):Observable<Object>{
    var url = this.getBaseUrl() + "parts/bootkitpart/rslpartupdate/" + partwo;
    return this.Http.get(url,{
      headers:this.getHeaders()
    });
  } 

  cancelOldReceipt(reqno):Observable<Object>{
    var url = this.getBaseUrl() + "parts/cancelreceipt/" + reqno;
    return this.Http.get(url,{
      headers:this.getHeaders()
    });
  }

  fetchFeEngineers():Observable<Object>{
    //console.log(this.headers);
    var url = this.getBaseUrl() + "parts/feengineers";
    return this.Http.get(url,{
      headers:this.getHeaders()
    })
  }

  rslStores(storevalue):Observable<Object>{
    var storeObj = {'storevalue' : storevalue};
    var url = this.getBaseUrl() + "parts/rslstores";
    return this.Http.post(url,storeObj,{
      headers:this.getHeaders()
    });
  }

  getParts(engValue):Observable<Object>{
    var url = this.getBaseUrl() + "parts/getparts/" + engValue;

    return this.Http.get(url,{
      headers:this.getHeaders()
    });
  }

  searchPart(part):Observable<Object>{
    var url = this.getBaseUrl() + "parts/searchparts/" + part;

    return this.Http.get(url,{
      headers:this.getHeaders()
    });
  }

  issueParts(woObj):Observable<Object>{
    var issuepartsObj = {'issueparts' : woObj};
    var url = this.getBaseUrl() + 'parts/issueparts';
    return this.Http.post(url,issuepartsObj,{
      headers:this.getHeaders()
    });
  }

  returnParts(woObj):Observable<Object>{
    var returnpartsObj = {'returnparts' : woObj};
    var url = this.getBaseUrl() + 'parts/returnparts';
    return this.Http.post(url,returnpartsObj,{
      headers:this.getHeaders()
    });
  }

  checkValidConsigment(cObj):Observable<Object>{
    console.log(cObj);
    var url = this.getBaseUrl() + 'parts/consignment';
    var consignment = {
      'consignment': cObj
    };
    console.log(consignment);
    return this.Http.post(url,consignment,{
      headers:this.getHeaders()
    });
  }

  receiptPart(rpObj):Observable<Object>{
    var url = this.getBaseUrl() + 'parts/receiptpart';

    return this.Http.post(url,rpObj,{
      headers : this.getHeaders()
    })
  }

  stockUpdate(suObj):Observable<Object>{
    var url = this.getBaseUrl() + 'parts/stockupdate';
    
    return this.Http.post(url,suObj,{
      headers : this.getHeaders()
    });
  }

  partsUpdate(partObj):Observable<Object>{
    var url = this.getBaseUrl() + 'parts/partupdate';
    
    return this.Http.post(url,partObj,{
      headers : this.getHeaders()
    });
  }

  transactions(tObj):Observable<Object>{
    var url = this.getBaseUrl() + "parts/transactions";
    var transaction = {
      'transactions': tObj
    };
    console.log(transaction);
    return this.Http.post(url,transaction,{
      headers:this.getHeaders()
    });
  }

  searchUser(user):Observable<Object>{
    var url = this.getBaseUrl() + "parts/getuser/" + user;
    return this.Http.get(url,{
      headers:this.getHeaders()
    });
  }

  insertUser(user):Observable<Object>{
    var userDetails = {
      'user':user
    };

    var url = this.getBaseUrl() + "parts/insertuser";
    return this.Http.post(url,userDetails,{
      headers:this.getHeaders()
    });
  }

  getStockLocation(value,searchstring,loctype):Observable<Object>{
    this.serviceUrl = this.service.baseurl + this.service[value].path + searchstring + this.service[value].type + loctype;
    console.log('Inservice module stock!', this.serviceUrl);
    return this.Http.get(this.serviceUrl);
  }

  getPortalService(value):Observable<Object>{
    this.serviceUrl = this.service.baseurl + this.service[value].path + localStorage.getItem('username');
    console.log('Inservice module portal !', this.serviceUrl);
    return this.Http.get(this.serviceUrl);
  }

  getMoveService(value,searchvalue):Observable<Object>{
    this.serviceUrl = this.service.baseurl + this.service[value].path + searchvalue;
    console.log('Inservice module move!', this.serviceUrl);
    return this.Http.get(this.serviceUrl);
  }
}
